var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUmbrella({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 18v1a3 3 0 1 0 6 0V1a1 1 0 1 0-2 0v18a1 1 0 1 1-2 0v-1H7Z",
    clipRule: "evenodd",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.764V10a8 8 0 1 1 16 0v1.764A2.989 2.989 0 0 0 18 11a2.99 2.99 0 0 0-2 .764A2.989 2.989 0 0 0 14 11a2.99 2.99 0 0 0-2 .764A2.989 2.989 0 0 0 10 11c-.768 0-1.47.289-2 .764A2.99 2.99 0 0 0 6 11c-.768 0-1.47.289-2 .764Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUmbrella);
export default __webpack_public_path__ + "static/media/ic_action_umbrella.80ea4b11ed56a7f5a0f2408d7f45f889.svg";
export { ForwardRef as ReactComponent };